/** 将 axios / 网络错误转成可读提示，避免和「查询结果为空」混淆 */

export function isRequestTimeout(err) {
  if (!err) return false;
  if (err.code === 'ECONNABORTED') return true;
  const msg = String(err.message || '');
  return /timeout/i.test(msg);
}

export function isNetworkError(err) {
  if (!err) return false;
  if (err.message === 'Network Error') return true;
  // 无 response 且非超时，多为断网 / CORS / 服务不可达
  return !err.response && !isRequestTimeout(err);
}

/**
 * @param {unknown} err
 * @param {string} [fallback] 其它错误时的默认文案
 */
export function requestErrorMessage(err, fallback = '请求失败，请稍后重试') {
  if (isRequestTimeout(err)) {
    return '查询超时，请稍候再试';
  }
  if (isNetworkError(err)) {
    return '网络异常，请检查网络后重试';
  }
  const status = err?.response?.status;
  if (status === 401 || status === 403) {
    return '登录已失效或无权限，请重新登录后再试';
  }
  if (status >= 500) {
    return '服务暂时繁忙，请稍候再试';
  }
  const data = err?.response?.data;
  const fromApi = data?.msg || data?.error || data?.message;
  if (fromApi) return String(fromApi);
  if (err?.message && !/timeout/i.test(err.message)) {
    return String(err.message);
  }
  return fallback;
}
